export const COMPANY = {
  NAME: 'Kairon Health',
  SHORT_NAME: 'Kairon',
}